// s3Operations.js

import AWS from "aws-sdk";
import axios from "axios";
import Cookies from "js-cookie";
import { withApiErrorResponse, apiErrorMessage } from "../utils/apiError";

const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL;

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_REGION,
});

// export async function uploadFileToS3(file) {
//   const uploadParams = {
//     Bucket: process.env.REACT_APP_BUCKET_NAME,
//     Key: file.name,
//     Body: file,
//   };
//   try {
//     const uploadData = await s3.upload(uploadParams).promise();
//     const url = uploadData.Location;
//     return url;
//   } catch (error) {
//     console.error("Error uploading file:", error);
//     throw withApiErrorResponse(error);
//   }
// }

export async function uploadFileToS3(file) {
  const token = Cookies.get("accessToken");

  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${baseURL}api/v1/s3/upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Do not set Content-Type manually: the browser needs to generate
          // it itself so it includes the multipart boundary. Setting it here
          // sends "multipart/form-data" with no boundary, which the backend
          // cannot parse, so uploads fail silently.
        }
      }
    );

    if (response.data.header.code === 600 && response.data.body?.value) {
      return response.data.body.value; // Return the uploaded file URL
    }

    throw new Error(apiErrorMessage(response.data, "File upload failed"));
  } catch (error) {
    console.error("Error uploading file:", error.message);
    throw withApiErrorResponse(error);
  }
}

export const deleteS3Object = async (fileUrl) => {
  const urlPath = new URL(fileUrl).pathname.slice(1); // Extract key from URL
  const params = {
    Bucket: process.env.REACT_APP_BUCKET_NAME,
    Key: urlPath, // Correct Key for S3 deletion
  };

  try {
    await s3.deleteObject(params).promise();
  } catch (error) {
    console.error('Error deleting file from S3:', error);
    throw withApiErrorResponse(error);
  }
};
